//@flow
import BaseFilter from './base_filter'
import type DataTables from 'datatables.net';

export default class Search extends BaseFilter {
    filters: {[string|null|void]: Set<string>}
    searchText: ?string
    context: (searchText: ?string) => void

    constructor(callback: () => void) {
        super(callback);
        this.filters = {}
        this.searchText = null;
        this.context = this.call.bind(this);
    }

    call(searchText: ?string): void {
        this.searchText = searchText;
        this.invoke()
    }

    addFilter(): void {
        this.filters[this.column] = this.filters[this.column] || new Set();
        this.filters[this.column].add(this.searchText ||'');
    }

    setFilter(): void {
        this.filters[this.column] = new Set([this.searchText || '']);
    }

    clearFilter(): void {
        if (this.searchText) {
            if (this.filters[this.column]) {
                this.filters[this.column].delete(this.searchText);
            }
            return;
        }
        if (this.column) {
            this.filters[this.column] = new Set();
        } else {
            this.filters = {}
        }
    }

    apply(dataTable: DataTables.Api): void {
        Object.keys(this.filters).forEach(filter => {
            if (this.filters[filter].size === 0) return;
            let filterText = `${Array.from(this.filters[filter]).join(' ')}`;

            if (filter !== 'undefined') {
                dataTable.column(`${filter}:name`)
                    .search(filterText, false, true);
            } else {
                dataTable.search(filterText, false, true);
            }
        }, this);
    }

    getDescription(): any {
        let keys = Object.keys(this.filters);
        switch(keys.length) {
            case 0: return {}
            case 1: return {text: Array.from(this.filters[keys[0]]).join(' ')}
            default: return {text: this.filters}
        }
    }
}
